import type { ComponentProps } from "react";
import { useId } from "react";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import ExternalScripts from "./ExternalScripts";
import { useWvSearch } from "~/hooks/useDataLayer";
import { useDebounce } from "@commercekit/react";

export function SooqrSearchInput({
  locale,
  sooqrAccount,
  id,
  ...props
}: {
  sooqrAccount: string;
  locale: string;
} & ComponentProps<"input">) {
  const { $pt } = usePrismicLabels();
  const randomId = useId().replace(/:/g, "_");
  id = id || randomId;

  const gtmSearch = useWvSearch();
  const debouncedGtmSearch = useDebounce(() => {
    const emitSearch = () => {
      const searchTerm = (document.getElementsByName("sooqrSearch")?.[0] as HTMLInputElement)?.value ?? "";
      let resultsCount = "";
      const searchContainer = document.querySelector("[data-sqr-container]");
      if (searchContainer) {
        const resultsText = searchContainer.querySelectorAll(".sqr-font-semibold span")[0]?.textContent;
        if (resultsText) {
          resultsCount = resultsText.split(" ")[0] ?? "";
        }
      }
      gtmSearch(searchTerm, resultsCount);
    };

    const pollUntilNoSpinner = (attempt = 0) => {
      const isLoading = Boolean(
        document.querySelector(".sqr-animate-spin") ||
        document.querySelector(".sqr-animate-pulse")
      );
      if (isLoading && attempt < 50) {
        setTimeout(() => pollUntilNoSpinner(attempt + 1), 100);
        return;
      }
      emitSearch();
    };

    pollUntilNoSpinner();
  }, 1000);
  const toggleNav = (e: React.FormEvent<HTMLInputElement>) => {
    const nav = document.querySelector(".wvheader");

    if (nav) {
      const searchTerm = e.currentTarget.value;
      if (searchTerm.length > 0) {
        setTimeout(() => {
          if (nav && nav.getBoundingClientRect().bottom < nav.clientHeight) {
            nav.classList.add("fixed");
          }
        }, 500);
        debouncedGtmSearch();
      } else {
        nav.classList.remove("fixed");
      }
    }
  };

  const sooqrScript = `
  ;(function(p,l,o,w,i,n,g) {
    p.GlobalSpotlerNamespace=p.GlobalSpotlerNamespace||[];
    if (p.GlobalSpotlerNamespace.indexOf(i)===-1) {
      p.GlobalSpotlerNamespace.push(i);
      p[i]=function(){
          (p[i].q=p[i].q||[]).push(arguments)
      };
      p[i].q=p[i].q||[];
      n=l.createElement(o);
      g=l.getElementsByTagName(o)[0];
      n.defer=1;
      n.src=w;
      g.parentNode.insertBefore(n,g)
    }
  }(window,document,"script","https://assets.spotlersearch.com/custom/customers/${sooqrAccount}/snippet.js","spotler_search"));
  
  
  var SPOTLER_INSIGHTS_SRC = "https://assets.spotlersearchanalytics.com/insights/1.0.0/spotler-search-insights.min.js";
  ;(function(s,p,o,t,l,e,r) {
    s.SpotlerInsightsPointer=l;
    s[l]=s[l]||function(){(s[l].queue=s[l].queue||[]).push(arguments)};
    e=p.createElement(o);
    r=p.getElementsByTagName(o)[0];
    e.defer=1;
    e.src=t;
    r.parentNode.insertBefore(e,r);
  }(window,document,"script",SPOTLER_INSIGHTS_SRC,"spotler_insights"));
  `;

  return (
    <>
      {/* <div id="sooqr"></div> */}
      <input
        type="text"
        id={id}
        name="sooqrSearch"
        className="search-field form-control w-100"
        placeholder={$pt("header_search_placeholder")}
        {...props}
        onInput={toggleNav}
      />
      <ExternalScripts
        scripts={[{ innerHTML: sooqrScript, id: "sooqr", insertToHead: true }]}
      />
    </>
  );
}
